export default __webpack_public_path__ + "static/media/arrow-carousel.b81be80e.png";